import ApiProvider from './ApiProvider';
import { ActionStatusType } from '../types/ActionStatusType';
import { DictionaryType } from '../types/DictionaryType';

const StylesApi = {
  fetchSettings: async () => {
    return await ApiProvider.get<
      ActionStatusType<DictionaryType<DictionaryType<string>>>
    >('Styles/getStyleSettings');
  },
};

export default StylesApi;
